import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { MeterModelSuggestions } from '../hooks/meter_models/useMeterModelDetails';

const INITIAL_STATE = {
  meterModelSuggestions: undefined,
} as const;

export interface MeterModelSuggestionsForm {
  meterModelSuggestions?: MeterModelSuggestions;
}

export type MeterModelSuggestionsStore = MeterModelSuggestionsForm & {
  setMeterModelSuggestions: (payload?: MeterModelSuggestions) => void;
  reset: () => void;
};

export const useMeterModelSuggestionsStore = create<MeterModelSuggestionsStore>(
  devtools<MeterModelSuggestionsStore>(
    set => ({
      ...INITIAL_STATE,
      setMeterModelSuggestions: (payload?: MeterModelSuggestions) => set(() => ({ meterModelSuggestions: payload })),
      reset: () => set(INITIAL_STATE),
    }),
    'MeterModelSuggestionsStore',
  ),
);
